import { AxiosError } from 'axios';

/**
 * Checks whether an axios error is a local Prisma unique-constraint conflict (409, via probonio-api's
 * `prismaCatcher`) on the given field. Prisma's `target` is an array of column names for `@@unique`
 * constraints, but a raw constraint-name string for plain-SQL-index constraints (e.g. Employee's
 * conditional `(tenantId, mail)` index) - handles both.
 */
export function isPrismaConflictOn(err: unknown, field: string): boolean {
  if (!(err instanceof AxiosError) || err.response?.status !== 409) return false;
  const target = (err.response.data as { data?: { target?: string[] | string } })?.data?.target;
  return Array.isArray(target) ? target.includes(field) : typeof target === 'string' && target.includes(field);
}
